export default [
  {
    path: '/activity-20260324-main',
    component: () => import('./Page.vue'),
    meta: { title: '春日庆典', id: 25 },
  },
  {
    path: '/activity-20260324-rule',
    component: () => import('./rule.vue'),
    meta: { title: '规则说明', id: 25 },
  },
]
